var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down filled triangular arrow 2",
    clipPath: "url(#clip0_8238_59523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.05939 2.34253H0.831196C0.489147 2.34253 0.314896 2.75557 0.560139 3.00082L4.17424 6.61494C4.32267 6.76338 4.56791 6.76338 4.71642 6.61494L8.33051 3.00082C8.57569 2.75557 8.40144 2.34253 8.05939 2.34253Z",
    fill: "#656565"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8238_59523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(0.445312 0.534424)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropdown);
export default __webpack_public_path__ + "static/media/arrow_dropdown.b300ebfd.svg";
export { ForwardRef as ReactComponent };